export const formatCurrency = (amount?: number): string => {
    if (amount === undefined || amount === null) return 'N/A';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(amount);
}

export const formatDate = (date?: string): string => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US');
}

export const formatBoolean = (value?: boolean): string => {
    if (value === undefined || value === null) return 'N/A';
    return value ? 'Yes' : 'No';
};